export const SCREENXSMIN = 480
export const SCREENSMMIN = 768
export const SCREENMDMIN = 992
export const SCREENLGMIN = 1280

export const SCREENXSMAX = SCREENSMMIN - 1
